"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hotSpotList = void 0;
var HotSpot_1 = __importDefault(require("./HotSpot"));
var service_1 = require("./service");
var HotSpotList = /** @class */ (function () {
    function HotSpotList() {
        this.spotList = [];
        this.subscribe();
    }
    HotSpotList.prototype.add = function (component, params, timeDelay) {
        if (params === void 0) { params = {}; }
        this.spotList.push(new HotSpot_1.default(component, params, timeDelay));
    };
    HotSpotList.prototype.remove = function (spot) {
        this.spotList = this.spotList.filter(function (item) { return item === spot; });
    };
    HotSpotList.prototype.subscribe = function () {
        var _this = this;
        setInterval(function () {
            var explosureList = [];
            _this.spotList = _this.spotList.filter(function (item) {
                var hasExplosure = item.hasExplosure;
                if (hasExplosure) {
                    explosureList.push(item.getParams());
                }
                return !hasExplosure;
            });
            if (explosureList.length > 0) {
                // console.log('发送请求', explosureList)
                try {
                    service_1.hotSpotServer.hotSpotLogs(explosureList.map(function (item) { return item.params; }));
                }
                catch (error) {
                    // console.log(error)
                }
            }
        }, 1000);
    };
    return HotSpotList;
}());
exports.hotSpotList = new HotSpotList();



//////////////////
// WEBPACK FOOTER
// ./node_modules/@weike/operation-report/dist/components/HotSpot/HotSpotList.js
// module id = 197
// module chunks = 0